var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapHoriz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21417 8.58333L2 11.8056L5.21417 15.0278V12.6111H10.8611V11H5.21417V8.58333ZM16.5 6.97222L13.2858 3.75V6.16667H7.63889V7.77778H13.2858V10.1944L16.5 6.97222Z",
    fill: "#4C657A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapHoriz);
export default __webpack_public_path__ + "static/media/swap-horiz.4e034412ffbbe21372354758cdad1636.svg";
export { ForwardRef as ReactComponent };